import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import toastMessages from "../helpers/toastMessage";
import axiosInstance from "../../api";
import { useHistory } from "react-router-dom";
import FileActions from "../FileActions";

type FormValues = {
  firstName: string;
  lastName: string;
  profileImage: string | File;
  email: string;
};

export const useUpdateProfileMutation = (oktaAuth?:any) => {
  const { authState } = useOktaAuth() ?? oktaAuth;
  const queryClient = useQueryClient();
  const [updating, setUpdating] = useState<boolean>(false);
  const history = useHistory();

  const UpdateProfile = async (values: FormValues | any) => {
    const config = {
      headers: {
        Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
      },
    };

    const fileActions = new FileActions();
    const updatedValues = { ...values };

    if (values.profileImage instanceof File) {
      const profileImage = await fileActions.uploadToAzure({
        type: "image",
        file: values.profileImage,
        token: authState?.accessToken?.accessToken ?? "",
      });

      updatedValues.profileImage = profileImage;
    }

    const response = await axiosInstance.put(
      "v1/users/new-flow/update-profile",
      updatedValues,
      config
    );
    return response.data;
  };

  const mutation = useMutation({
    mutationFn: UpdateProfile,
    onMutate: async () => {
      setUpdating(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
      setUpdating(false);
      // history.goBack();
      toastMessages.success("Profile updated successfully.");
    },
    onError: (error) => {
      console.error("Mutation error:", error);
      toastMessages.error("Update failed.");
      setUpdating(false);
    },
    onSettled: () => {
      setUpdating(false);
    },
  });

  return { mutation, updating };
};
